import type { CampaignOverviewRequest } from '@/api/types';
import type { Instant } from '@/lib/datetime';
import { resolveCampaignsOverviewSearch } from '@/lib/campaigns-overview-search';
import type { CampaignsOverviewSearch } from '@/lib/campaigns-overview-search';

/**
 * One builder shared by the route loader, mounted screen, and CSV export.
 *
 * A defaulted range is resolved against `now`, so the request — and with it
 * the query key the resource derives from it — names the last 30 completed
 * New York days as of the call, not as of the navigation that produced the
 * search. The loader and the screen call this on the same day and land on
 * the same key; after ET midnight the key moves and the slot rolls over.
 */
export function buildCampaignOverviewRequest(
  search: CampaignsOverviewSearch,
  now: Instant = Date.now(),
): CampaignOverviewRequest {
  const resolved = resolveCampaignsOverviewSearch(search, now);
  return {
    from: resolved.from,
    to: resolved.to,
    campaign_id: resolved.campaignId ?? null,
    q: null,
    channel: resolved.channel ?? null,
    status: null,
    operational_status: resolved.status ?? null,
    production_id: resolved.productionId ?? null,
    audience_types: [...resolved.audienceTypes],
    sort: resolved.sortField,
    direction: resolved.sortDirection,
  };
}
